import React from 'react';
import classnames from 'classnames';

import logo from '../../../assets/img/logo.png';
import eu from '../../../assets/img/EU.png';
import { Card } from '../../shared/components/card/card.component';
import { sceneCount } from '../../shared/constants/constants';
import comic1 from '../../../assets/img/comics/ERRIN_VulnerablePerson_comic.pdf';
import comic2 from '../../../assets/img/comics/ERRIN_family_comic.pdf';
import comic3 from '../../../assets/img/comics/ERRIN_SingleMan_comic.pdf';
import 'bulma/css/bulma.css';
import styles from './home.module.scss';

export const Home = () => {
  const width = window.innerWidth;
  // The width below which the mobile view should be rendered
  const breakpoint = 620;
  return (
    <>
      <div className={styles.container}>
        <div className={styles.navbar}>
          <img className={styles.logo} src={logo} alt="logo" />
          <img className={styles.eu} src={eu} alt="logo" />
        </div>
        <div className={classnames(styles.home)}>
          <div className={classnames("container", styles.homeContainer)}>
            <div className={classnames(styles.noMargin, 'columns is-multiline')}>
              <div className='column is-full'>
                <h1 className={styles.title}>Empowering returnees to build new lives in their home countries</h1>
              </div>
              <div className='column is-full'>
                <h2>CLEAR INFORMATION, REALISTIC EXPECTATIONS, INFORMED CHOICES</h2>
              </div>

                <div className={classnames(styles.descriptionbox, 'is-hidden-tablet is-hidden-desktop')}>
                  <div className={classnames(styles.description, 'column')}>
                    <span>Feelings of alienation, administrative complexity and disinformation mean that prospective returnees often face a disorienting array of information and a lack of clear perspective. Follow the three journeys to learn about possible support provided to individuals who are considering going back home from Europe and help them make informed choices. </span>
                    <br /> <br />
                    <span>You will accompany three characters throughout the entire process to see how ERRIN can support people to return in a dignified manner, stand on their own two feet - and successfully reintegrate into their local communities.</span>
                  </div>
                </div>
                
                <div className={classnames(styles.descriptionbox, 'is-hidden-mobile')}>
                  <div className={classnames(styles.description, 'column is-half')}>
                    <span>Feelings of alienation, administrative complexity and disinformation mean that prospective returnees often face a disorienting array of information and a lack of clear perspective. Follow the three journeys to learn about possible support provided to individuals who are considering going back home from Europe and help them make informed choices.</span>
                  </div>
                  <div className={classnames(styles.description, 'column is-half')}>
                    <span> You will accompany three characters throughout the entire process to see how ERRIN can support people to return in a dignified manner, stand on their own two feet - and successfully reintegrate into their local communities.</span>
                  </div>
                </div>
              

              

              <div className='column is-one-third'></div>
              <div className={classnames(styles.sectionTitle, 'column is-one-third')}>
                Follow the journey of...
              </div>
              <div className='column is-one-third'></div>

              <div className='column'>
                <Card 
                  storyId={1} 
                  sceneCount={sceneCount[0]}
                  name={'Tania'}
                  title={'Tania is promised a good job and a better life in Europe by an \'aunt\'.'}
                  paragraph={<><p>However, once there, she ends up in a strip club. She finds her way to the national migration authorities who tell her about the possibility to apply for ERRIN reintegration support.</p> <p>She does so successfully and, once back in the home country, receives support from the local ERRIN partner. They provide counseling and inform her about different options for receiving training or finding a job. Eventually, she finds the job she was promised in Europe locally.</p></>}
                  comic={comic1}
                />
              </div>
              <div className='column'>
                <Card 
                  storyId={3} 
                  sceneCount={sceneCount[0]}
                  name={'Fatima\'s family'}
                  title={'Fatima, her husband Mohamed and their two children are in a difficult situation in the host country: Mohamed is sick, the couple did not get work permits, and the children cannot go to school.'}
                  paragraph={<><p>They find their way to the national migration authorities who tell them about the possibility to apply for ERRIN reintegration support.</p> <p>They do so successfully and, once back in the home country, receive support from the local ERRIN partner. They help them reunite with friends / family, provide counseling and inform them about the different support options.</p> <p>Thanks to this support, Mohamed receives the treatment he needs, Fatima finds work in a store, and the children can go to school. They are (re) integrated into the home community.</p></>}
                  comic={comic2}
                />
              </div>
              <div className='column'>
                <Card 
                  storyId={2} 
                  sceneCount={sceneCount[0]}
                  name={'Sekou'}
                  title={'Sekou came to Europe seeking asylum but finds himself in a difficult situation: he is isolated, has no work and faces financial difficulties.'}
                  paragraph={<><p>He fears he has let down his parents, who count on his financial support.</p> <p>He finds his way to the national migration authorities and tells them about his struggles. They tell him about the possibility to apply for ERRIN reintegration support.</p> <p>He does so successfully and, once back in the home country, receives support from the local ERRIN partner. They inform him about different options for rebuilding a life and support him as he decides to start a business.</p> <p>Thanks to this support, Sekou makes a living and can face up to his parents, whom he can now support thanks to his new activity.</p></>}
                  comic={comic3}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};